import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeleteStreamClipMutation } from "../graphql/mutations";
import type {
  DeleteStreamClipMutationType,
  DeleteStreamClipMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDeleteStreamClipMutation = (
  options?: MutationHookOptions<
    DeleteStreamClipMutationType,
    DeleteStreamClipMutationVariablesType
  >
) => {
  return useMutation<
    DeleteStreamClipMutationType,
    DeleteStreamClipMutationVariablesType
  >(DeleteStreamClipMutation, options);
};
